import "./MultiSelectFilterInput.scss"
import { FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox } from "@mui/material"
import { IBaseMapFilterOption } from "../../../../shared/models/map_models"
import { useEffect, useState } from "react"

interface IMultiSelectFilterInputProps {
    label: string
    value: string | null
    options: Array<IBaseMapFilterOption>
    valueChanged: (value: string) => void
}


const MultiSelectFilterInput = (props: IMultiSelectFilterInputProps) => {

    const [inputValue, setInputValue] = useState<string[]>([])

    useEffect(() => {

        if(props.value !== null && props.value !== '')
            setInputValue(props.value.split(","))
        else
            setInputValue([])

    }, [props.value])

    const handleOptionSelect = (newValue: string | string[]) => {
        if (Array.isArray(newValue)){
            setInputValue(newValue)
            props.valueChanged(newValue.join(","))
        }
        else{
            setInputValue([newValue])
            props.valueChanged(newValue)
        }

    }

    return (
        <div className="multi-select-filter-input-wrapper">
             <FormControl sx={{m: 1}} className="multi-select-form" size="small">
                <InputLabel id={`${props.label}-multiselect-label`}>{props.label}</InputLabel>
                <Select
                    sx={{textAlign: "left"}}
                    multiple
                    labelId={`${props.label}-multiselect-label`}
                    value={inputValue || []}
                    onChange={(e) => handleOptionSelect(e.target.value || '')}
                    input={<OutlinedInput label={props.label} />}
                    renderValue={(selected) => selected ? selected.join(",") : ''}
                    size="small"
                    label={props.label}
                >
                {props.options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                        <Checkbox checked={inputValue?.includes(option.value)} />
                        <div className="map-filter-multi-select-option-value-wrapper">
                             <span 
                                key={index}
                                className="option-value"
                                style={{
                                    background: option.bg_color && option.bg_color,
                                    color: option.text_color && option.text_color,
                                }}
                            >{option.value}</span>
                        </div>
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default MultiSelectFilterInput